import { window } from '../../../globals';
import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';

// async so the thrown error becomes a rejected Promise for mutationFn consumers
async function removeOrganizationLogo() {
  const organizationId = window.user?.organizationId;
  if (!organizationId) {
    throw new Error('Missing organizationId when attempting to remove organization logo.');
  }
  return remove(`/api/organizations/${organizationId}/logo`);
}

/**
 * Hook for removing organization logo.
 */
export default function useRemoveOrganizationLogo() {
  return useToastedMutation({
    mutationFn: removeOrganizationLogo,
    successToastMessage: 'Logo removed successfully',
    errorToastMessage: 'Failed to remove logo',
    onSuccess: () => {
      if (window.user?.organization) {
        window.user.organization.image = undefined;
      }
      queryClient.invalidateQueries({ queryKey: ['organization'] });
    },
  });
}
